(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Customer-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStories(root) {
      if (root.dataset.storiesInit) return;
      root.dataset.storiesInit = '1';

      var dialog = root.querySelector('.stories__modal');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('.stories__avatar[data-src]'));
      if (!dialog || !buttons.length || typeof dialog.showModal !== 'function') return;

      var imgEl = dialog.querySelector('.stories__figure-img');
      var avatarEl = dialog.querySelector('.stories__figure-avatar');
      var nameEl = dialog.querySelector('.stories__figure-name');
      var handleEl = dialog.querySelector('.stories__figure-handle');
      var prevBtn = dialog.querySelector('.stories__nav--prev');
      var nextBtn = dialog.querySelector('.stories__nav--next');
      var closeBtn = dialog.querySelector('.stories__close');
      var current = 0;

      function show(i) {
        current = (i + buttons.length) % buttons.length;
        var b = buttons[current];
        var src = b.getAttribute('data-src');
        var name = b.getAttribute('data-name') || '';
        var handle = b.getAttribute('data-handle') || '';
        if (imgEl) { imgEl.src = src; imgEl.alt = name; }
        if (avatarEl) { avatarEl.src = src; avatarEl.alt = name; }
        if (nameEl) nameEl.textContent = name;
        if (handleEl) { handleEl.textContent = handle; handleEl.style.display = handle ? '' : 'none'; }
        var single = buttons.length <= 1;
        if (prevBtn) prevBtn.style.display = single ? 'none' : '';
        if (nextBtn) nextBtn.style.display = single ? 'none' : '';
      }

      function open(i) {
        show(i);
        if (!dialog.open) dialog.showModal();
      }

      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () { open(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(current - 1);
        else if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.stories').forEach(initStories);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
